import dayjs from "dayjs";

/**
 * Helpers de fechas ISO `YYYY-MM-DD` ↔ `Date`. Aislados acá porque el
 * Date constructor de JS tiene un bug clásico de timezone (parsea un
 * string sin hora como UTC midnight y al formatear vuelve a hacer
 * conversión local · resultado: salta un día).
 *
 * Nuestro fix: añadir `T12:00:00` al parsear y formatear con dayjs
 * que es timezone-agnóstico cuando recibe una Date local.
 */
export function parseIso(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  return new Date(`${iso}T12:00:00`);
}

export function formatIso(d: Date | string | null): string {
  if (!d) return "";
  return dayjs(d).format("YYYY-MM-DD");
}

/**
 * Parsea un datetime ISO 8601 COMPLETO (con hora) → Date. A diferencia de
 * `parseIso`, no necesita el hack de mediodía: al traer hora, el Date
 * constructor no tiene el bug de "salta un día" (solo ocurre con fechas
 * puras sin hora).
 */
export function parseIsoDateTime(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Formatea a ISO 8601 completo (UTC) para persistir un ajuste tipo FechaHora. */
export function formatIsoDateTime(d: Date | string | null): string {
  if (!d) return "";
  const date = typeof d === "string" ? new Date(d) : d;
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
}

/** Desfase FIJO de la zona de negocio (UTC-6 · CDMX sin horario de verano · mismo criterio que el backend). */
const OFFSET_NEGOCIO_MS = -6 * 60 * 60 * 1000;

/**
 * Hotspot 59 · "hoy" en la zona de negocio UTC-6, como `Date` LOCAL a medianoche (para `minDate`
 * de los selectores de fecha de pago). El backend rechaza fechas anteriores con el mismo criterio.
 */
export function hoyNegocio(ahora: Date = new Date()): Date {
  const negocio = new Date(ahora.getTime() + OFFSET_NEGOCIO_MS);
  return new Date(negocio.getUTCFullYear(), negocio.getUTCMonth(), negocio.getUTCDate());
}
